import React from "react";
import { Container, Group, Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { scroller } from "react-scroll";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./header.module.scss";
import "./styles.scss";

const links = [
  { link: "features", label: "Hva får du?" },
  { link: "process", label: "Prosessen" },
  { link: "about", label: "Om meg" },
  { link: "contact", label: "Ta kontakt" },
  { link: "priser", label: "Priser" },
];

const scrollTo = (link) =>
  scroller.scrollTo(link, {
    duration: 800,
    smooth: "easeInOutQuart",
    offset: -70,
  });

export function HeaderComponent() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLinkClick = (link) => {
    close();

    if (link === "priser") {
      navigate("/priser");
      window.scrollTo(0, 0);
      return;
    }

    if (location.pathname !== "/home") {
      navigate("/home");
      setTimeout(() => scrollTo(link), 100);
    } else {
      scrollTo(link);
    }
  };

  const handleHomeClick = () => {
    close();
    if (location.pathname !== "/home") {
      navigate("/home");
    } else {
      window.scrollTo(0, 0);
    }
  };

  const items = links.map((link) => (
    <a
      key={link.label}
      href={link.link === "priser" ? "/priser" : `#${link.link}`}
      className={classes.link}
      onClick={(event) => {
        event.preventDefault();
        handleLinkClick(link.link);
      }}
    >
      {link.label}
    </a>
  ));

  return (
    <header className={classes.header}>
      <Container size="md" className={classes.inner}>
        <picture>
          <source
            type="image/avif"
            srcSet="/optimized/logo-768.avif 768w, /optimized/logo-1024.avif 1024w"
            sizes="162px"
          />
          <source
            type="image/webp"
            srcSet="/optimized/logo-768.webp 768w, /optimized/logo-1024.webp 1024w"
            sizes="162px"
          />
          <img
            src="/optimized/logo-768.webp"
            alt="Moderne Coaching – til forsiden"
            style={{ cursor: "pointer", height: "28px" }}
            width="162"
            height="28"
            onClick={handleHomeClick}
          />
        </picture>
        <Group
          gap={5}
          className={`${classes.links} ${
            opened ? classes.menuOpen : classes.menuClosed
          }`}
        >
          {items}
        </Group>
        <Burger
          opened={opened}
          onClick={toggle}
          hiddenFrom="xs"
          size="sm"
          aria-label={opened ? "Close navigation menu" : "Open navigation menu"}
        />
      </Container>
    </header>
  );
}
